import { useContext } from 'react';

import AutoTranslateContext from './AutoTranslateContext';

export const useAutoTranslate = () => {
  return useContext(AutoTranslateContext);
};